/**
 * One narrator channel for the whole app: starting a line stops the previous one,
 * so recorded voice, device speech and the video never talk over each other.
 */
let current: HTMLAudioElement | null = null;

export function stopVoice() {
  if (current) {
    current.pause();
    current = null;
  }
  if (typeof window !== 'undefined') window.speechSynthesis?.cancel();
}

/** Plays a recorded line; falls back to device speech if it cannot play. */
export function playVoice(src: string | undefined, fallbackText?: string): Promise<void> {
  stopVoice();
  if (!src) return speak(fallbackText);
  const audio = new Audio(src);
  current = audio;
  return new Promise((resolve) => {
    audio.onended = () => resolve();
    audio.onerror = () => {
      void speak(fallbackText).then(resolve);
    };
    audio.play().catch(() => {
      // Autoplay blocked or file missing: speech is the fallback.
      void speak(fallbackText).then(resolve);
    });
  });
}

export function speak(text?: string): Promise<void> {
  if (!text || typeof window === 'undefined' || !('speechSynthesis' in window)) return Promise.resolve();
  window.speechSynthesis.cancel();
  return new Promise((resolve) => {
    const u = new SpeechSynthesisUtterance(text);
    u.lang = 'en-IN';
    u.rate = 0.9;
    u.onend = () => resolve();
    u.onerror = () => resolve();
    window.speechSynthesis.speak(u);
  });
}
